import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import Image from '@/app/common/components/Image/Image'
import { currencyFormatter } from '@/app/common/utilities'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout'
import { ReviewItem } from '@/app/pages/family_application/review/ReviewItem'
import { SubmitButton } from '@/app/pages/family_application/student_details/shared/submit-button'
import { PursesArray } from '@/schemas/provider.schema'
import { MutationStatus } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { ReimbursementDetails } from '../../create_reimbursement_form'

interface Props {
  paymentDetails: ReimbursementDetails
  onSubmit: () => void
  mutationStatus: MutationStatus
  apiPurses: PursesArray
}

function ReviewDetails(props: Props) {
  const { paymentDetails, onSubmit, mutationStatus, apiPurses } = props

  const { t } = useTranslation()

  const isAppeal = window.location.href.includes('appeal')


  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1>{t('reimbursement_details')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className={'w-full space-y-4'}>
        <Card className="">
          <CardHeader className="flex items-center justify-between">
            <h2 className="font-bold text-gray-700">{t('order_details')}</h2>
          </CardHeader>
          <CardContent>
            <ReviewItem
              title={paymentDetails.store_name}
              value={currencyFormatter.format(paymentDetails.amount)}
            />
            <ReviewItem
              title={t('comments')}
              value={paymentDetails.comments}
            />
            <ReviewItem
              title={t("po_number1")}
              value={paymentDetails.invoiceNumber}
            />
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="font-bold text-gray-700">
            Documents
          </CardHeader>
          <CardContent className="grid grid-cols-2 lg:grid-cols-3 gap-4 ">
            {paymentDetails.documents.map((document) => {
              return (
                <div className="border border-gray-300 h-40 w-40 overflow-hidden rounded-lg">
                  <Image
                    allowZoom={true}
                    className="object-cover w-full h-full"
                    path={document}
                  />
                </div>
              )
            })}
          </CardContent>
        </Card>
        <Card className="mb-8">
          <CardHeader className="flex items-center justify-between">
            <h2 className="font-bold text-gray-700">{t('purse')}</h2>
          </CardHeader>
          <CardContent>
            <ul className="divide-y divide-gray-200 dark:divide-gray-700">
              {paymentDetails.purses?.map((purse, index) => {
                const purseData = apiPurses.find((p) => p.id === purse.purse_id)
                return (
                  <li className="py-3 sm list-none" key={index}>
                    <div className="flex items-center space-x-4 rtl:space-x-reverse justify-between">
                      <div>
                      <p className="text-sm font-medium dark:text-white">
                          {t(purse.name)}
                      </p>
                        <p className='text-sm text-gray-600'>
                          {purseData && purseData.student_name}
                        </p>
                      </div>
                      <p className="text-gray-800 text-sm">
                        {currencyFormatter.format(purse.amount)}{' '}
                      </p>
                    </div>
                  </li>
                )
              })}
            </ul>
          </CardContent>
        </Card>
        <Card className="mb-8">
          <CardHeader className="flex items-center justify-between">
            <h2 className="font-bold text-gray-700">{t('expense_type')}</h2>
          </CardHeader>
          <CardContent>
            <ul className="divide-y divide-gray-200 dark:divide-gray-700">
              {paymentDetails.expenseCategories.map((detail, index) => {
                return (
                  <ReviewItem
                    key={index}
                    title={detail.name}
                    value={currencyFormatter.format(detail.amount)}
                  />
                )
              })}
            </ul>
          </CardContent>
        </Card>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar className="fixed max-w-[15rem] md:max-w-sm bottom-0 ">
        <SubmitButton
          buttonTxt={isAppeal ? t("submit_reimbursement_appeal") : t('submit_reimbursement')}
          onClick={onSubmit}
          status={mutationStatus}
        />
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}

export default ReviewDetails
